import { render } from "./GradingCharts.vue?vue&type=template&id=5210327c"
import script from "./GradingCharts.vue?vue&type=script&lang=js"
export * from "./GradingCharts.vue?vue&type=script&lang=js"

import "./GradingCharts.vue?vue&type=style&index=0&id=5210327c&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__